import { FunctionComponent } from 'react';

// Components
import Access from './Access';
import Image from '@Components/Utils/Image';

// Styles
import styles from './QuickSupport.module.scss';

// Analytics
import { trackingEvent } from '@Components/Utils/Lazy/Script';

// Contexts
import { useAskQuestion } from '@Pages/hoi-dap/Context';
import { useGetShowIconQuestion } from '@Pages/hoi-dap/Context';
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Utilities
import classnames from 'classnames';
import { useRouter } from 'next/router';

const REGEX =
    /((\/tra-cuu\/bac-si\/)|(\/gop-y)|(\/ho-tro)|(\/cong-tac-vien)|(\/tra-cuu\/phong-kham\/)|(\/tu-van-suc-khoe).*)/;

const QuickSupport: FunctionComponent = () => {
    const router = useRouter();
    const { setModal } = useAskQuestion();
    const { deviceType } = useViewDetected();
    const { showQuestionIcon } = useGetShowIconQuestion();

    const handlePopup = () => {
        setModal.askQuestion(true);

        //trackingEvent
        trackingEvent('nhấp vào nút "Đặt câu hỏi miễn phí"', 'Nút "Hỏi bác sĩ miễn phí"');
    };

    const isMobile = deviceType !== 'desktop';

    const className = classnames([
        styles.wrapper,
        styles[deviceType],
        {
            [styles.mb_80]: REGEX.test(router.asPath) && isMobile,
        },
    ]);

    return (
        <div className={className}>
            {(isMobile || showQuestionIcon) && router.asPath.includes('hoi-dap') && (
                <Image
                    width={140}
                    height={48}
                    onClick={handlePopup}
                    className={styles.icon_question}
                    src="/assets/cong_dong_v2/icon_question.png"
                />
            )}
            <Access />
        </div>
    );
};

export default QuickSupport;
